import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NavController } from "@ionic/angular";
import { AuthService } from "src/app/_services/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { NavigationService } from "src/app/_services/navigation-service.service";
@Component({
  selector: "app-email-forgot-password",
  templateUrl: "./email-forgot-password.page.html",
  styleUrls: ["./email-forgot-password.page.scss"],
})
export class EmailForgotPasswordPage implements OnInit {
  email: any;
  emailError: boolean = false;
  emailErrorMessage: string = "";
  submitted = false;
  isLoading = false;
  disabled = false;
  textType = "password";
  textTypeConfirmPw = "password";
  textTypeNewMdp = "password";

  showModal: boolean = false;
  resetPasswordForm = this.fb.group({
    email: ["", Validators.required],
  });
  constructor(
    private fb: FormBuilder,
    private navController: NavController,
    private authService: AuthService,
    private translateService: TranslateService,
    private navigationService: NavigationService,
    private router: Router
  ) {}
  ngOnInit() {}

  get f() {
    return this.resetPasswordForm.controls;
  }

  checkEmail() {
    let emailControlErr = this.resetPasswordForm.controls["email"];
    emailControlErr.errors
      ? (this.emailError = true)
      : (this.emailError = false);
    if (emailControlErr.errors) {
      this.emailError = true;
      this.f["email"].hasError("required")
        ? (this.emailErrorMessage = this.translateService.instant(
            "FORGOT_PW_PAGE.ERRORS.VALID_EMAIL"
          ))
        : this.f["email"].hasError("userNotFound")
        ? (this.emailErrorMessage = this.translateService.instant(
            "FORGOT_PW_PAGE.ERRORS.VALID_EMAIL"
          ))
        : this.f["email"].hasError("email")
        ? (this.emailErrorMessage = this.translateService.instant(
            "FORGOT_PW_PAGE.ERRORS.VALID_EMAIL"
          ))
        : "";
    } else {
      this.emailError = false;
    }
  }
  removeError() {
    this.submitted = false;
    this.emailError = false;
    this.emailErrorMessage = "";
  }
  submitForm() {
    this.submitted = true;
    this.isLoading = true;
    if (this.resetPasswordForm.invalid) {
      this.isLoading = false;
      this.checkEmail();
      return;
    }
    !this.disabled &&
      this.authService
        .forgotPassword({ email: this.resetPasswordForm.value.email })
        .subscribe(
          (res: any) => {
            this.disabled = false;
            this.isLoading = false;

            if (res.status === 200) {
              this.router.navigate(["/verifier-numero-telephone"], {
                queryParams: { email: this.resetPasswordForm.value.email },
              });
            }
          },
          (errors: HttpErrorResponse) => {
            this.disabled = false;
            this.isLoading = false;
            let errorMessage = errors.error.message;
            switch (errorMessage) {
              case "The email field must be a valid email address.":
                this.resetPasswordForm
                  .get("email")!
                  .setErrors({ invalid: true });
                this.emailError = true;
                this.emailErrorMessage = this.translateService.instant(
                  "FORGOT_PW_PAGE.ERRORS.VALID_EMAIL"
                );
                break;
              case "The selected email is invalid.":
                this.resetPasswordForm
                  .get("email")!
                  .setErrors({ invalid: true });
                this.emailError = true;
                this.emailErrorMessage = this.translateService.instant(
                  "FORGOT_PW_PAGE.ERRORS.VALID_EMAIL"
                );

                break;
            }
          }
        );
    this.disabled = true;
  }

  backto() {
    this.navigationService.goToPreviousPage();
  }
  get provider() {
    return this.resetPasswordForm.controls;
  }
}
